import React from "react";
import AntTreeSelect, { TreeSelectProps } from "antd/lib/tree-select";
import "./tree-select.less";

export const TreeSelect = <T extends (string | number)[]>(props: TreeSelectProps<T>) => (
  <AntTreeSelect {...props} />
);
export const { TreeNode, SHOW_ALL, SHOW_CHILD, SHOW_PARENT } = AntTreeSelect;
